/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useSWR from 'swr';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import { Pathname } from 'Routes';
import { Button } from 'Components';
import { AppContext, AuthContext } from 'Context';
import { AxiosCancelToken, dataFetcher, endpoints } from 'Api';
import { isMobile } from 'react-device-detect';
import { encryptedKeyForCredentials, GOOGLE_RECAPTCHA_KEY } from 'Commons';
import { AuthPage } from '../components/page';
import { Snackbar } from '../../../../Components/index';
import styles from './index.module.css';

export const NewMobileVerification = () => {
  const navigate = useNavigate();
  const { setAppSnackbar, userDetails, setUserDetails, plansPage, setPlansPage, langText, setReferralStatus } = useContext(AppContext);
  const isDesktopApp = sessionStorage.getItem('isDesktopApp') === 'true';
  const mobileVerificationText = langText?.mobileVerification;
  const commonText = langText?.common;
  const signUpText = langText?.signInUp;
  const email = sessionStorage.getItem(encryptedKeyForCredentials.email);
  const [phoneNumber, setPhoneNumber] = useState();
  const [securityToke, setSecurityToken] = useState();
  const [selectedReCAPTCHA, selectReCAPTCHA] = useState(false);
  const [recaptcha, setRecaptcha] = useState('');
  console.log('recaptcha', recaptcha);
    const reCaptchaHandler = () => {
    if (window.grecaptcha && window.grecaptcha.execute) {
      window.grecaptcha.execute(GOOGLE_RECAPTCHA_KEY, { action: 'submit' }).then((value) => {
        if (value) {
          setRecaptcha(value);
          selectReCAPTCHA(true);
        } else {
          selectReCAPTCHA(false);
        }
      });
    }
  };
  useEffect(() => {
    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);
      if (!isScriptExist) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.id = id;
        script.onload = function () {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }
      if (isScriptExist && callback) callback();
    };
    loadScriptByURL('recaptcha-key', `https://www.google.com/recaptcha/api.js?render=${GOOGLE_RECAPTCHA_KEY}`, () => {
      if (window.grecaptcha && window.grecaptcha.ready) {
        window.grecaptcha.ready(() => {
          reCaptchaHandler();
        });
      }
    });
  }, []);

  const { isValidating: requestingCode, mutate: requestVerificationCode } = useSWR([endpoints.sendOtpToMobile, email, securityToke, recaptcha], {
    fetcher: (url, email, token, recaptcha) => dataFetcher(url, { email, tempToken: token, recaptcha }),
    onSuccess: ({ success, message }) => {
      if (success) {
        sessionStorage.setItem('#fs656gfhllh@#$', true);
        navigate(Pathname.authentication.newverifyCode);
        setAppSnackbar({ message: message || 'Otp Resend', isVisible: true });
      } else {
        setAppSnackbar({
          message: 'Code send to mobile number' || message || 'Oops! Something went wrong',
          isVisible: true,
        });
        reCaptchaHandler();
      }
    },
    onError: (error) => {
      const responseData = error?.response?.data;
      setAppSnackbar({
        message: responseData?.message || 'Oops! Something went wrong',
        isVisible: true,
      });
      reCaptchaHandler();
  },
});

  const defaultSnackbar = { isVisible: false, message: '', type: '' };
  const [snackbarData, setSnackbar] = useState(defaultSnackbar);
  const { isValidating: updatingMobile, mutate: updateMobile } = useSWR(
    [endpoints.updateMyProfile, phoneNumber, email],
    {
      fetcher: (url, inputMobile, email) => dataFetcher(url, { mobile: inputMobile, email }),
      onSuccess: ({ success, message, token }) => {
        if (success) {
          setUserDetails({ ...userDetails, mobile: phoneNumber });
          sessionStorage.setItem('mvt', token);
          setSecurityToken(token);
          requestVerificationCode();
        } else {
          setAppSnackbar({
            isVisible: true,
            message:
              message
              || 'Oops! Something went wrong while updating phone number',
          });
        }
      },
      onError: (error) => {
        const responseData = error?.response?.data;
        setSnackbar({ isVisible: true, message: responseData?.message });
      },
    }
  );

  const handleCancel = () => {
    if (isDesktopApp) {
      const isWindows = sessionStorage.getItem('isWindowsDesktop') === 'true';
      const callbackScheme = isWindows ? 'http://localhost:8080/callback' : 'projector-app://callback';
      window.location.href = `${callbackScheme}?error=cancelled`;
    } else {
      navigate(-1);
    }
  };

  useEffect(() => {
    setPhoneNumber(sessionStorage.getItem(encryptedKeyForCredentials.mobile));
  }, []);
  return (
    <>
      <AuthPage>
      {
        !isMobile && <div aria-hidden="true" onClick={() => { navigate(-1); }} className={styles.backLink}>BACK</div>
      }
      {
        isDesktopApp && <div aria-hidden="true" onClick={handleCancel} className={styles.backLink}>Cancel</div>
      }
       <form className={styles.alignForm} onSubmit={(e) => { e.preventDefault(); updateMobile(); }}>
          <div className={styles.inputLabel}>{mobileVerificationText?.enterYourPhoneNumber || 'Enter your phone number'}</div>
          <div className={styles.description}>
            Enter your phone number to activate and verify your account.
            <br />
            We want to keep your content safe and make sure this is you.
          </div>
          <br />
          <div className={styles.phoneButtonBlock}>
            <PhoneInput
              placeholder={
                mobileVerificationText?.enterYourPhoneNumber
                || 'Enter your phone number'
              }
              value={phoneNumber}
              onChange={setPhoneNumber}
              countryCallingCodeEditable={false}
              defaultCountry="US"
            />
          </div>
          <br />
          <div className={styles.buttonBlock}>
            <Button
              blockText
              isDisabled={
                !phoneNumber
                || !phoneNumber?.length
                || updatingMobile
                || requestingCode
              }
              isBlue
              isLarge
              submit
              isFullWidth
            >
              {mobileVerificationText?.continue || 'Continue'}
            </Button>
          </div>
       </form>
        <Snackbar
          {...snackbarData}
          onClose={() => {
            setSnackbar({ ...snackbarData, isVisible: false });
          }}
        />
      </AuthPage>
    </>
  );
};
